export default __webpack_public_path__ + "media/titles/title_2_locale_sv-38a5a276.png";